import {createAsyncThunk} from '@reduxjs/toolkit'

import {qs} from '@shared/helpers/queryString'

import {PAY} from '@web/core/urls'
import {unsubscribeMessage, subscribeMessage, changeBrowserLocation, openPopup} from '@web/helpers/browser'
import {isMobile} from '@web/helpers/userAgent'

import {NavigationResult, NavigationTypeSelectableParam, PopupMessageReceiveParam, ThunkApi} from '../interfaces'

const PAYMENT_LIMIT_SETTING_URL = `${PAY}/member/settings/payment-security/pay`

const POPUP_KEY = 'CHANGE_PAYMENT_LIMIT'
const MESSAGE_KEY = 'submit_payment_security'

/**
 * FDS 결제한도 수정 페이지로 이동
 */
const navigateToFDSPaymentLimit = createAsyncThunk<
    NavigationResult,
    (NavigationTypeSelectableParam & PopupMessageReceiveParam) | void,
    ThunkApi
>('navigateTo/FDSPaymentLimit', async (args) => {
    const {forceLocationChange = false, bridgeUrl = ''} = args ?? {}
    const shouldChangeLocation = forceLocationChange || isMobile

    if (shouldChangeLocation) {
        const url = qs.stringifyUrl({
            url: PAYMENT_LIMIT_SETTING_URL,
            query: {
                // returnUrl : 뒤로가기 클릭시 되돌아올 url
                returnUrl: window.location.href,
                // rurl: 한도 변경 후 되돌아올 url
                rurl: window.location.href,
                // backType 'back': 뒤로가기로 되돌아와 history stack 쌓이지 않음. 'replace' 다른 화면으로 replace로 이동해 history 쌓이지 않음
                backType: 'back',
            },
        })

        changeBrowserLocation({
            url,
            type: 'PUSH',
        })
        // page 이동은 그 자체로 추가동작 없이 resolve 된다
        return Promise.resolve()
    }

    const popupUrl = qs.stringifyUrl({
        url: PAYMENT_LIMIT_SETTING_URL,
        query: {
            closeType: 'close',
        },
    })

    return new Promise<void | string>((resolve, reject) => {
        const resolveCallback = () => resolve(MESSAGE_KEY)

        // popup으로부터 유효한 메시지 받았을 때만 result로  메시지 전달
        subscribeMessage({messageKey: MESSAGE_KEY, subscriber: resolveCallback})

        // popup만 오픈
        openPopup({
            key: POPUP_KEY,
            url: popupUrl,
            size: {
                width: 440,
                height: 620,
            },
            ...(bridgeUrl && {
                popupQuery: {
                    rurl: `${bridgeUrl}/${MESSAGE_KEY}/success`,
                },
            }),
        })
            .then(() => resolve())
            .catch(reject)
            .finally(() => {
                // popup open 실패했든 종료했든 popup open시도가 끝났다면 message subscription 종료
                unsubscribeMessage({messageKey: MESSAGE_KEY, subscriber: resolveCallback})
            })
    })
})

export default navigateToFDSPaymentLimit
